module.exports = "/images/mandarin-hsk-exam.jpg?1092b4a905e48ba0f9d7c828c6d487d3";